import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=3063905e&scoped=true&"
import script from "./integralDetails.vue?vue&type=script&lang=js&"
export * from "./integralDetails.vue?vue&type=script&lang=js&"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=3063905e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063905e",
  null
  
)

export default component.exports